export type FigureProps = {
  className?: string;
  stroke?: number;
};

export const FigureOvalOutline: React.FC<FigureProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="-1 -1 176 55"
      className={`pointer-events-none ${className ?? ''}`}>
      <path
        d="M1.19341 13.2985C16.8334 -11.1524 167.116 1.46323 173.476 24.1583C183.498 59.9242 46.7608 56.6727 27.2715 44.9675C26.5497 44.534 26.6678 43.7332 27.2715 43.9054C80.0867 58.9704 176.285 49.4545 168.135 24.1583C158.737 4.88808 4.76528 -8.89802 4.14106 17.6338C3.73006 35.1029 72.6656 51.5571 122.533 46.3115C124.024 46.5282 122.85 47.4761 121.215 47.6771C67.7412 53.2754 -10.6096 36.6267 1.19341 13.2985Z"
        fill="currentColor"></path>
    </svg>
  );
};

export const FigureEnvelopeCheck: React.FC<FigureProps> = ({
  className,
  stroke,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 157 142"
      className={className}>
      <path
        d="M157 55V142H0V55L78.5 0L157 55ZM78.5 88.1162L3 57.8203V139H154V57.8203L78.5 88.1162ZM4.79102 55.3057L78.5 84.8828L152.208 55.3057L78.5 3.66309L4.79102 55.3057Z"
        fill="currentColor"
      />
      <line
        x1="21"
        y1="121.5"
        x2="37"
        y2="121.5"
        stroke="currentColor"
        strokeWidth={stroke ?? '4'}
        strokeLinecap="round"
      />
      <path
        d="M21 114H57"
        stroke="currentColor"
        strokeWidth={stroke ?? '4'}
        strokeLinecap="round"
      />
      <path
        d="M121 9C122.105 9 123 9.89543 123 11V67.0244L78.5 84.8828L34 67.0283V11C34 9.89543 34.8954 9 36 9H121ZM101.538 28.2959C100.367 27.1243 98.4665 27.1243 97.2949 28.2959L70.249 55.3398L60.7041 45.7959C59.5325 44.6243 57.6335 44.6243 56.4619 45.7959C55.2906 46.9675 55.2904 48.8666 56.4619 50.0381L68.1279 61.7051C69.2994 62.8766 71.1995 62.8764 72.3711 61.7051L101.538 32.5381C102.709 31.3666 102.709 29.4674 101.538 28.2959Z"
        fill="#D4C2B3"
      />
    </svg>
  );
};
